import { Button } from "@/src/components/buttons";
import { Card } from "@/src/components/cards";
import { openDrawer } from "@/src/components/dialogs";
import { FetchableList } from "@/src/components/fetchableLists";
import SearchBar from "@/src/components/searchBar";
import { DocumentTemplate, DocumentTemplateType } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getUserId, jsonAbstract, uid } from "@/src/utils/utils";
import { useState } from "react";
import { openTemplateEditor } from "./documentsHook";
import { USER } from "@/src/data/globalVariables";
import { DocumentTemplateForm } from "../admin/referentiel/documentTemplateForm";

function DocumentTemplateChoiceList({
  defaultTemplates,
  onSelect,
  types,
}: {
  defaultTemplates?: DocumentTemplate[] | undefined | null;
  types: DocumentTemplateType[] | undefined | null;
  onSelect: (newValue: DocumentTemplate) => void;
}) {
  const [reload, setReload] = useState(0);
  let [searchKey, setSearchKey] = useState("");

  async function openTemplateCreationDialog(
    documentTemplate: DocumentTemplate
  ) {
    await openDrawer({
      id: "documentTemplateCreationDrawer",
      title: "Créer un document",
      content: (
        <DocumentTemplateForm
          current={documentTemplate}
          onChange={(newValue) => {
            documentTemplate = newValue;
          }}
        />
      ),
      onConfirm: async () => {
        let result = await apiFetch(
          "documentTemplates",
          "addOne",
          {
            documentTemplate,
          },
          "Erreur lors de la création du document"
        );
        documentTemplate = result;
        setReload((prev) => prev + 1);

        await openTemplateEditor({
          template: documentTemplate,
          onSave: async (newValue) => {
            documentTemplate = newValue;

            let result = await apiFetch(
              "documentTemplates",
              "addOne",
              {
                documentTemplate,
              },
              "Erreur lors de la mise à jour du document"
            );
            documentTemplate = result;
            setSearchKey("");
            setReload((prev) => prev + 1);
            onSelect(documentTemplate);
          },
        });
      },
    });
  }

  return (
    <div className="c1 gap10">
      {!defaultTemplates?.length && (
        <SearchBar
          placeholder="Rechercher un formulaire..."
          value={searchKey}
          onChange={(newValue) => {
            setSearchKey(newValue || "");
          }}
        ></SearchBar>
      )}
      <FetchableList
        queryKey={["DocumentTemplateChoiceList", searchKey, reload]}
        queryFn={async () => {
          let frequentTemplates = USER.get()?.speciality?.frequentTemplates;
          console.log("frequentTemplatessss", frequentTemplates);
          console.log("speciaaality", USER.get()?.speciality);
          if (!searchKey && frequentTemplates) return frequentTemplates;
          if (!searchKey && defaultTemplates) return defaultTemplates;
          return await apiFetch(
            "documentTemplates",
            "loadMany",
            {
              searchKey,
              types,
              creatorId: getUserId(),
            },
            "Erreur lors du chargement des modèles de documents"
          );
        }}
        emptyChild={
          searchKey && (
            <div className="center grid c1 gap10 p20">
              Aucun document disponible
              <Button
                onClick={async () => {
                  let documentTemplate: DocumentTemplate = {
                    name: `${searchKey || ""}`,
                    title: `${searchKey || ""}`,
                    format: "a4",
                    content: "",
                    creator: getUserId(),
                    showHeader: true,
                    showLeftBar: true,
                    barcodeLocation: "none",
                    showTitle: true,
                    showPatientIdentity: true,
                    isValidatable: false,
                    parent: null,
                    type: "standard",
                  };

                  await openTemplateCreationDialog(documentTemplate);
                }}
              >
                Créer {searchKey}
              </Button>
            </div>
          )
        }
      >
        {(data) => (
          <div className="grid c1 gap10">
            {data?.map((template, index) => {
              if (!template) return null;
              // if(template.registryName) return null;
              if (template.parent) return null;
              return (
                <Card
                  key={uid()}
                  color="simple"
                  title={template.name}
                  onClick={async () => {
                    onSelect(jsonAbstract(template) as DocumentTemplate);
                  }}
                  onEdit={async () => {
                    await openTemplateCreationDialog(template);
                  }}
                ></Card>
              );
            })}
          </div>
        )}
      </FetchableList>
    </div>
  );
}

export { DocumentTemplateChoiceList };
